import MediaLibraryFileEdit from './MediaLibraryFileEdit';

export default MediaLibraryFileEdit;
